import { render, staticRenderFns } from "./form-family-composition.vue?vue&type=template&id=fb50f240&scoped=true&"
import script from "./form-family-composition.vue?vue&type=script&lang=js&"
export * from "./form-family-composition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb50f240",
  null
  
)

export default component.exports